import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  role: "img",
  "aria-label": "Connectera"
}
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]

import { computed } from "vue";
// defineProps and withDefaults are compiler macros; this project's ESLint config predates them.
// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ConnecteraMark',
  props: {
    light: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;
const color = computed(() => (props.light ? "#2563EB" : "#60A5FA"));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M47.56 16.44A22 22 0 1 0 47.56 47.56",
      fill: "none",
      stroke: color.value,
      "stroke-width": "7",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_2),
    _createElementVNode("circle", {
      cx: "24",
      cy: "32",
      r: "4",
      fill: color.value
    }, null, 8, _hoisted_3),
    _createElementVNode("circle", {
      cx: "33.5",
      cy: "32",
      r: "4",
      fill: color.value,
      opacity: ".62"
    }, null, 8, _hoisted_4),
    _createElementVNode("circle", {
      cx: "43",
      cy: "32",
      r: "4",
      fill: color.value,
      opacity: ".32"
    }, null, 8, _hoisted_5)
  ]))
}
}

})